import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-input-section',
    templateUrl: './input.html',
})
export class InputTypeComponent extends FieldType { }
